import Phaser from 'phaser';

import { BlocksMainScene } from '../../scenes/blocks-main-scene';
import { BlockViewModel } from './block-view-model';
//import { DebugContainerVisual } from '../debug/debug-container-visual';
import { Subscription } from 'rxjs';

export class BlockView extends Phaser.GameObjects.Container {
  private blockImage: Phaser.GameObjects.Image;

  private blockScaler = 0.6;

  private subscriptionGroup: Subscription;
  //private debugContainerVisual: DebugContainerVisual;

  constructor(
    scene: BlocksMainScene,
    x: number,
    y: number,
    private viewModel: BlockViewModel,
  ) {
    super(scene, x, y);

    this.subscriptionGroup = new Subscription();
    //this.debugContainerVisual = new DebugContainerVisual(scene, this);

    this.blockImage = scene.add.image(0, 0, viewModel.asset.type).setOrigin(0.5, 0.5);
    this.add([this.blockImage]);

    this.setName(BlockView.name);
    scene.add.existing(this);

    this.subscriptionGroup.add(
      this.viewModel.isHighlighted$.subscribe((isHighlighted) => {
        this.blockImage.setTexture(
          isHighlighted ? viewModel.highlightedAsset.type : viewModel.asset.type,
        );
      }),
    );
    this.subscriptionGroup.add(
      this.viewModel.isValid$.subscribe((isValid) => {
        this.blockImage.alpha = isValid ? 1.0 : 0.3;
      }),
    );
  }

  override destroy(_fromScene?: boolean | undefined): void {
    this.subscriptionGroup.unsubscribe();

    super.destroy(_fromScene);
  }

  public onResize(scaleFactor: number, scaledOffsetX: number, isDragging: boolean) {
    this.resizeBlock(scaleFactor, scaledOffsetX, isDragging);
  }

  public blockPosition(
    scaleFactor: number,
    scaledOffsetX: number,
    isDragging: boolean,
  ): { x: number; y: number } {
    const layoutConfig = this.viewModel.layoutConfig;
    const cellBorder = layoutConfig.cellBorder * (isDragging ? 1.0 : this.blockScaler);
    const blockSz =
      ((layoutConfig.boardWidth - layoutConfig.cellBorder) / 9) *
      (isDragging ? 1.0 : this.blockScaler);
    const innerCellSz = blockSz - cellBorder;

    const cellSize = innerCellSz + cellBorder;
    const halfCellSize = cellSize * 0.5;

    const gridPosX = this.viewModel.block.posInShape.col * cellSize + innerCellSz * 0.5;
    const gridPosY = this.viewModel.block.posInShape.row * cellSize + innerCellSz * 0.5;

    const centerOffsetX = this.viewModel.uniqueCellsX * halfCellSize - cellBorder * 0.5;
    const centerOffsetY = this.viewModel.uniqueCellsY * halfCellSize - cellBorder * 0.5;

    return {
      x: (gridPosX - centerOffsetX) * scaleFactor,
      y: (gridPosY - centerOffsetY) * scaleFactor,
    };
  }

  private blockSize(scaleFactor: number, isDragging: boolean): { width: number; height: number } {
    const layoutConfig = this.viewModel.layoutConfig;
    const cellBorder = layoutConfig.cellBorder * (isDragging ? 1.0 : this.blockScaler);
    const blockSz =
      ((layoutConfig.boardWidth - layoutConfig.cellBorder) / 9) *
      (isDragging ? 1.0 : this.blockScaler);
    const innerCellSz = (blockSz - cellBorder) * scaleFactor;

    return { width: innerCellSz, height: innerCellSz };
  }

  private resizeBlock(scaleFactor: number, scaledOffsetX: number, isDragging: boolean): void {
    const pos = this.blockPosition(scaleFactor, scaledOffsetX, isDragging);
    const sz = this.blockSize(scaleFactor, isDragging);

    this.setPosition(pos.x, pos.y);
    this.setSize(sz.width, sz.height);

    this.blockImage.setDisplaySize(sz.width, sz.height);
  }
}
